import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import Modal from 'react-modal';
import { getModalStyling } from '../../../../../../shared/utils/ModalUtils';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../../shared/components/VerbButton';
import VerbHeading from '../../../../../../shared/components/VerbHeading';

const TeamConfirmationModal = (props) => {
    const { isOpen, toggleModal, onSubmit, saveAndExit = false } = props;
    const handleSubmit = () => {
        onSubmit(saveAndExit).then(toggleModal);
    };
    return (
        <Modal
            className={cns('verb-modal admin-to-users-email-modal admin-modal')}
            style={getModalStyling({ content: { width: '700px' } })}
            isOpen={isOpen}
            contentLabel={'Modal'}
        >
            <div className={'close-container'}>
                <i className={'fal fa-times'} onClick={toggleModal} />
            </div>
            <div className={'baseModal main-panel'}>
                <div className={'row'}>
                    <VerbHeading
                        className={'modal-header'}
                        messageId={'UPDATE_PATHWAY'}
                        defaultMessage={`Are you sure you want to make these changes?`}
                        hNumber={2}
                    />
                </div>
                <br />
                <div className={'row'}></div>
                <br />
                <div className={'bottom-panel'}>
                    <div className={'row'}>
                        <VerbButton
                            className={'col-xs'}
                            textId={'BUTTON_CANCEL'}
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                            defaultMessage={'CANCEL'}
                            onClick={toggleModal}
                        />
                        <VerbButton
                            className={'col-xs ms-auto submit-button'}
                            type={'submit'}
                            textId={'BUTTON_SAVE'}
                            defaultMessage={'SAVE'}
                            fontAwesomeIcon={'fa-save'}
                            onClick={handleSubmit}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

TeamConfirmationModal.propTypes = {
    isOpen: PropTypes.bool,
    toggleModal: PropTypes.func,
    onSubmit: PropTypes.func,
    saveAndExit: PropTypes.bool
};

export default TeamConfirmationModal;
